import classnames from 'classnames';
import React from 'react';

import { ClickableText } from 'src/components/common/clickableText/ClickableText';
import { PermissionWarning } from 'src/components/permissionGuards/permissionWarning/PermissionWarning';

interface Props {
  graphId: string;
  onUndoClick: () => void;
  exactlyOneChange: boolean;
}

export function UndoMarkAsSafeButton({
  graphId,
  onUndoClick,
  exactlyOneChange,
}: Props) {
  return (
    <div className="my-1 flex items-center rounded border border-silver bg-silver-light px-4 py-2 text-sm">
      <span className="truncate italic">
        Change{exactlyOneChange ? '' : 's'} marked as safe
      </span>
      <PermissionWarning
        graphId={graphId}
        graphPermissions="canWriteCheckConfiguration"
        childRenderer={(hasPermission) => (
          <ClickableText
            as="a"
            className={classnames(
              'ml-2',
              hasPermission ? 'text-link' : 'cursor-default text-secondary',
            )}
            onClick={hasPermission ? onUndoClick : undefined}
            disabled={!hasPermission}
          >
            Undo
          </ClickableText>
        )}
      />
    </div>
  );
}
